import { Image, QRCode, Modal } from "antd";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
import { shouldShowComponent } from "../../../utils/componentVisibility";

const AddLoginFields = (props) => {
  const shouldShow = shouldShowComponent(config.project, "AddLoginFields");

  if (!shouldShow) {
    return null; // Do not render if the condition is not met
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: 'space-between',
          textAlign: "center",
          paddingTop: "8px",
          gap: '15px'
        }}
      >
        {" "}
        <Image
          style={{ cursor: "pointer" }}
          src={require("../../../assets/images/app-images/google-play-btn.png")}
          onClick={() => {
            props.handleGoogleStates();

          }}
        ></Image>

        <Image
          style={{ cursor: "pointer" }}
          src={require("../../../assets/images/app-images/app-store-btn.png")}
          onClick={() => {
            props.handleAppleStates();
          }}
        ></Image>

        <Image
          style={{ cursor: "pointer" }}
          src={require("../../../assets/images/app-images/app-gallery-btn.png")}
          onClick={() => {
            props.handleAppGalleryStates();
          }}
        ></Image>
      </div>


      <Modal
        open={props.This.openModalForQRCode}
        onCancel={props.closeqrPopup}
        // onCancel={() => this.setState({ openModalForQRCode: false })}
        footer={null}
        title="Scan QRCode to Download App!"
        width={350}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {props.This.showGoogleQRCode && (
            <div style={{ marginTop: 20, alignItems: "center" }}>
              <QRCode value="https://play.google.com/store/apps/details?id=com.awtl.track" />
            </div>
          )}

          {props.This.showQRCode && (
            <div style={{ marginTop: 20, alignItems: "center" }}>
              <QRCode value="https://apps.apple.com/us/app/awtltrack/id1507353643" />
            </div>
          )}

          {props.This.showAppGalleryQRCode && (
            <div style={{ marginTop: 20, alignItems: "center" }}>
              <QRCode value="https://appgallery.cloud.huawei.com/ag/n/app/C102853095?locale=en_US" />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

AddLoginFields.contextType = StoreContext;
export default observer(withRouter(AddLoginFields));
